<template>
  <div class="activity-box ">
    <b-card class="mb-1  shadow bg-white rounded">
      <div class="activity-item">
        <div class="container-circle">
          <div class="round">
            {{ iniciales(ticket.solicitante) }}
          </div>
        </div>
        <div class="m-t-10">
          <h5 class="m-b-0 font-medium">{{ ticket.solicitante }} <span class="text-muted font-14 m-l-10">| &nbsp;
              {{ mostrarFecha(ticket.created_at) }}</span></h5>
          <h6 class="text-muted">Comentarios</h6>
          <p>{{ ticket.descripcion }}</p>
        </div>
      </div>
    </b-card>



    <!-- Activity item-->
    <div v-show="sw" >

      <b-card class="mb-1 shadow bg-white rounded" v-for="(value, key) in activity" :key="key">
        <div class="activity-item">
          <div class="container-circle">
            <div class="round">

              {{ iniciales(value.usuario) }}

            </div>
          </div>

          <div class="d-flex flex-column">
            <h5 class="m-b-5 font-medium">{{ value.usuario }} <span class="text-muted font-14 m-l-10">| &nbsp;
                {{ mostrarFecha(value.created_at) }}</span></h5>
            <h6 class="text-muted">Comentarios</h6>
            <p>{{ value.descripcion }}</p>
          </div>
        </div>
      </b-card>
    </div>
    
    <!-- Activity item-->
  </div>
  
</template>

<script>
  import {mapState,mapActions} from 'vuex'
  import moment from 'moment'
  export default {
    props:{
      activity:{
        type: Array,
        
      },
      ticket:{
        type: Object,
        required:true
      },
     
    },
    data: function () {
      return {
        sw: false
      }
    },
    mounted() {
      this.init()
    },//mounted
    computed: {
      //variable del state que tiene el id del login.
      ...mapState('login', ['id']),
   
     
    },//computed   
    methods: {
      
     
      init() {
        // se atrapa el warning si es indefinido ( no tiene actividad)
        if (this.activity != undefined){
          this.sw = true
        }

      },

      /**
       * Metodo que muestra las inicialies del usuario.
       * @param {*} value 
       */
      iniciales(value) {
        let name = value.split(' ')
        return `${name[0].charAt(0)}${name[1] ? name[1].charAt(0) : ''}`;
      },
      mostrarFecha(value) {
        moment.locale('es')
        return moment(value).format('LLLL');
      },
    }
  }
</script>

<style lang="scss" scoped>
  .activity-box .activity-item {
      display: flex;
      margin-bottom: 30px;
      
  }
  .round {
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      
      width: 50px;
      height: 50px;
      
      line-height: 48px;
      color: #ffffff;
      display: inline-block;
      font-weight: 400;
      text-align: center;
      
      background: #398bf7;


      margin-right: 20px;
  }

  .container-circle {
    width:  100px;
    height: auto;

  }
</style>